module.exports = __webpack_public_path__ + "assets/2e5d7de3abf7b45ce935ce5d7d217875.mp3";